import { buildValidation, VALIDATIONS } from '~utils/schema';

import { FIELDS } from './constants';

export const validationSchema = (signInWithEmailLink) =>
  signInWithEmailLink
    ? buildValidation({
        [FIELDS.NAME]: VALIDATIONS.name,
        [FIELDS.PHONE]: VALIDATIONS.phone
      })
    : buildValidation({
        [FIELDS.EMAIL]: VALIDATIONS.email
      });
